import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { DeviceInfoHistoryComponent } from '../device-info-history/device-info-history.component';

@Component({
  standalone: false,
  selector: 'kt-signin-device-info',
  templateUrl: './signin-device-info.component.html',
  styleUrls: ['./signin-device-info.component.scss']
})
export class SigninDeviceInfoComponent extends ModalBaseClass implements OnInit {

  @Input() employeeDetails = null;

  devicesName = {
    IPAD_KIOSK: "iPad-Kiosk",
    IPHONE_KIOSK: "iPhone-Kiosk",
    IPHONE: "iPhone",
    ANDROID_TABLET_KIOSK: "Android-Tablet-Kiosk",
    ANDROID_KIOSK: "Android-Kiosk",
    ANDROID: "Android",
    WEB: "Web",
  }

  constructor(public modalService: NgbModal,) { super(modalService); }

  ngOnInit() {
  }

  ngOnChanges() {
  }

  deviceClick(type, data) {
    if (type && data && this.employeeDetails && this.employeeDetails.employee_fk_user_id) {
      // console.log('OK', this.employeeDetails.employee_fk_user_id);
      this.openPopUp(DeviceInfoHistoryComponent, { data: { type, user_id: this.employeeDetails.employee_fk_user_id } },
        { centered: true, size: 'xl', keyboard: true, backdrop: 'static' },
      );
    }
  }
}
